import React from "react";
import { LeftColumn, RightColumn, Container } from "./TwoColumnContainer.styled";

const TwoColumnContainer = ({ leftContent, rightContent }) => {
  return (
    <Container>
      <LeftColumn>{leftContent}</LeftColumn>
      <RightColumn>{rightContent}</RightColumn>
    </Container>
  );
};

export default TwoColumnContainer;

